import { render } from "./ReviewDetail.vue?vue&type=template&id=53055142&scoped=true"
import script from "./ReviewDetail.vue?vue&type=script&lang=js"
export * from "./ReviewDetail.vue?vue&type=script&lang=js"

import "./ReviewDetail.vue?vue&type=style&index=0&id=53055142&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53055142"]])

export default __exports__